import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react'
import { Link } from 'react-router-dom';
import useScrollToTop from '../components/useScrollToTop.js';
import { FiX } from "react-icons/fi";
import { FaUniversity } from "react-icons/fa";


const BankDetailsModal = ({ show, onClose }) => {
    useScrollToTop();
    if (!show) return null;

    return (
        <div>
            <Transition show={show}>
                <Dialog className="relative z-50" onClose={onClose}>
                    <TransitionChild
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-75 transition-opacity" />
                    </TransitionChild>

                    <div className="fixed inset-0 z-50 w-screen h-screen overflow-y-auto">
                        <div className="flex min-h-full items-start justify-center p-4 text-center sm:items-center sm:p-0">
                            <TransitionChild
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"

                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <DialogPanel className="relative w-full max-h-screen overflow-y-auto transform rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg lg:max-w-xl xl:max-w-2xl 2xl:max-w-7xl">

                                    {/* <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 p-4"> */}
                                    {/* <div className="bg-white rounded-2xl shadow-xl p-6 w-full text-center relative"> */}
                                    <button
                                        className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                                        // onClick={() => setIsOpen(false)}
                                        onClick={onClose}
                                    >
                                        <FiX size={24} />
                                    </button>
                                    <div className="flex flex-col py-16 items-center">
                                        <div className="bg-blue-100 p-4 rounded-full">
                                            <FaUniversity size={50} className="text-slate-800" />
                                        </div>
                                        <h2 className="text-xl font-semibold mt-4">Add Bank Details</h2>
                                        <p className="text-gray-600 mt-2 px-6">
                                            Bank details are mandatory to Manifest COD Shipments.
                                        </p>
                                        <Link to='/sellerprufdetails'>  <button className="mt-4 px-6 py-2 bg-slate-800 text-white rounded-md hover:bg-slate-900 transition">
                                            Add Bank Info
                                        </button></Link>
                                    </div>
                                    {/* </div> */}
                                    {/* </div> */}
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </div>
                </Dialog>
            </Transition>

        </div>
    )
}

export default BankDetailsModal
